module.exports = __webpack_public_path__ + "img/step42_a_tear_the_plastic.205123c1.png";